import React from 'react';
import PropTypes from 'prop-types';
import { Space } from 'antd';

import FormInputError from '../../Form/FormInputError';

import { perpetualMassFormNames } from './perpetualMassFormNames';

export const Address = ({ loading, register, errors }) => {
  return (
    <Space direction="vertical" className="d-flex" size="middle">
      <div>
        <div className="md-form input-group mb-0">
          <input
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            disabled={loading}
            className="form-control"
            type="text"
            id={perpetualMassFormNames.country}
            {...register(perpetualMassFormNames.country)}
          />
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor={perpetualMassFormNames.country}>Kraj</label>
        </div>

        {errors[perpetualMassFormNames.country] && (
          <FormInputError errorText={errors[perpetualMassFormNames.country].message} />
        )}
      </div>

      <div>
        <div className="md-form input-group mt-0 mb-0">
          <input
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            disabled={loading}
            className="form-control"
            type="text"
            id={perpetualMassFormNames.city}
            {...register(perpetualMassFormNames.city)}
          />
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor={perpetualMassFormNames.city}>Miasto</label>
        </div>

        {errors[perpetualMassFormNames.city] && (
          <FormInputError errorText={errors[perpetualMassFormNames.city].message} />
        )}
      </div>

      <div>
        <div className="md-form input-group mt-0 mb-0">
          <input
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            disabled={loading}
            className="form-control"
            type="text"
            id={perpetualMassFormNames.zipCode}
            {...register(perpetualMassFormNames.zipCode)}
          />
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor={perpetualMassFormNames.zipCode}>Kod pocztowy</label>
        </div>

        {errors[perpetualMassFormNames.zipCode] && (
          <FormInputError errorText={errors[perpetualMassFormNames.zipCode].message} />
        )}
      </div>

      <div>
        <div className="md-form input-group mt-0 mb-0">
          <input
            // eslint-disable-next-line jsx-a11y/no-autofocus
            autoFocus
            disabled={loading}
            className="form-control"
            type="text"
            id={perpetualMassFormNames.street}
            {...register(perpetualMassFormNames.street)}
          />
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label htmlFor={perpetualMassFormNames.street}>Ulica i numer</label>
        </div>

        {errors[perpetualMassFormNames.street] && (
          <FormInputError errorText={errors[perpetualMassFormNames.street].message} />
        )}
      </div>
    </Space>
  );
};

Address.propTypes = {
  loading: PropTypes.bool,
  register: PropTypes.func,
  errors: PropTypes.object,
};
